import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  border-radius: ${({ theme }) => theme.rounded.x3};
  padding: ${({ theme }) => theme.spacing.x4};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  position: relative;
`;
export const TransactionSatatus = styled.div<{ $color }>`
  border-radius: ${({ theme }) => theme.rounded.x3};
  padding: ${({ theme }) => theme.spacing.x3};
  padding-inline-start: ${({ theme }) => theme.spacing.x6};

  box-shadow: ${({ theme }) => theme.boxShadow.md};
  display: flex;
  justify-content: space-between;
  max-width: 1498px;
  margin-inline: auto;
  margin-bottom: ${({ theme }) => theme.spacing.x2};
  flex-direction: column;
  ${({ $color }) =>
    $color === 'ok'
      ? css`
          background-color: ${({ theme }) => theme.palette.success10};
          color: ${({ theme }) => theme.palette.success};
        `
      : $color === 'reverse-fail'
      ? css`
          background-color: ${({ theme }) => theme.palette.error10};
          color: ${({ theme }) => theme.palette.error};
        `
      : css`
          background-color: ${({ theme }) => theme.palette.warn10};
          color: ${({ theme }) => theme.palette.warn};
        `}
`;
export const NotOk = styled.div`
  padding: ${({ theme }) => theme.spacing.x10};
`;
export const CardResult = styled.div`
  border-radius: ${({ theme }) => theme.rounded.x3};
  padding: ${({ theme }) => theme.spacing.x3};
  padding-inline-start: ${({ theme }) => theme.spacing.x6};
  background-color: ${({ theme }) => theme.palette.white};
  box-shadow: ${({ theme }) => theme.boxShadow.md};
  display: flex;
  justify-content: space-between;
  max-width: 1498px;
  margin-inline: auto;
  margin-bottom: ${({ theme }) => theme.spacing.x2};
  @media (max-width: ${({ theme }) => theme.media.md}) {
    flex-direction: column;
  }
`;
export const TitleCard = styled.p`
  padding: ${({ theme }) => theme.spacing.x3};
`;

export const DetailsWrapper = styled.div`
  flex-grow: 1;
`;
export const Details = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: start;
  flex-wrap: wrap;
  + * {
    margin-top: ${({ theme }) => theme.spacing.x2};
  }
`;
export const AmountBlockWrapper = styled.div`
  display: flex;
  margin: -${({ theme }) => theme.spacing.x2};
  margin-inline-start: ${({ theme }) => theme.spacing.x6};
  > * {
    padding: ${({ theme }) => theme.spacing.x1};
    width: 200px;
  }
  @media (max-width: ${({ theme }) => theme.media.md}) {
    justify-content: space-between;
    margin-inline-start: 0px;
    margin-top: ${({ theme }) => theme.spacing.x2};
  }
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    flex-direction: column;
    align-items: center;
  }
`;

export const DetailsCenterBlock = styled.div`
  width: ${({ theme }) => theme.spacing.x15};
  margin-inline: ${({ theme }) => theme.spacing.x6};
  text-align: center;
  color: ${({ theme }) => theme.palette.lightGray};
`;

export const DetailsCenterBlockIcon = styled.div``;

export const parentItems = styled.div`
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 10px;
  }
`;

export const TinyText = styled.span`
  font-size: ${({ theme }) => theme.fs.xxs};
  font-weight: 400;
  line-height: ${({ theme }) => theme.spacing.x4};
  color: ${({ theme }) => theme.palette.lightGray};
  display: block;
`;

export const SmallText = styled(TinyText)`
  font-size: ${({ theme }) => theme.fs.xs};
  color: ${({ theme }) => theme.palette.lightGray};
`;

export const ContainerFlight = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    justify-content: center;
    align-items: center;
  }
`;
export const FlightNumber = styled.div`
  font-size: ${({ theme }) => theme.fs.xs};
  color: ${({ theme }) => theme.palette.gray80};
  display: inline-block;
  margin-top: ${({ theme }) => theme.spacing.x1};
`;
export const SliderBarHeaderSvg = styled.svg`
  font-size: ${({ theme }) => `${theme.fs.xxxl}`};
  color: ${({ theme }) => `${theme.palette.gray10}`};
  background-color: ${({ theme }) => `${theme.palette.gray40}`};
  padding: ${({ theme }) => theme.spacing.x1};
`;
